// extracted by mini-css-extract-plugin
module.exports = {"promotional__carousel":"styles_promotional__carousel__Mir0U"};